import { Guarantor } from '@zappyrent/hundop';
import { rem, rgba } from 'polished';
import styled from 'styled-components/macro';

export const StyledNarrowerContainer = styled.div`
  margin: 0 auto;
  margin-top: ${rem('40px')};
  padding: 0 10%;

  & > *:last-child {
    margin-bottom: 0;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    width: 100%;
  }
`;

export const StyledAddGuarantorButton = styled.button`
  border: none;
  cursor: pointer;
  outline: none;
  background: none;
  border: ${rem('1px')} dashed ${({ theme }) => theme.colors.cross.grayson};
  border-radius: ${rem('8px')};
  padding: ${rem('16px')} ${rem('24px')};
  width: 100%;
  margin-bottom: ${rem('40px')};
  color: ${({ theme }) => theme.colors.cross.grayson};
  text-align: left;
  transition: all 0.2s;

  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (hover: hover) {
    &:hover {
      border: ${rem('1px')} dashed ${({ theme }) => theme.colors.tenant.main};
      background-color: ${({ theme }) =>
        rgba(theme.colors.tenant.mainPale, 0.5)};
    }
  }
`;

export const StyledAddGuarantorButtonTitle = styled.p`
  margin: 0;
  font-size: ${rem('16px')};
  font-weight: 600;
`;

export const StyledAddGuarantorButtonText = styled.p`
  margin: 0;
  font-size: ${rem('12px')};
  margin-top: ${rem('8px')};
`;

export const StyledGuarantorIcon = styled(Guarantor)`
  width: auto;
  height: ${rem('40px')};
  padding: 0;
  background-color: transparent;
  border: none;
  appearance: none;
  cursor: pointer;

  path {
    fill: ${({ theme }) => theme.colors.tenant.main};
  }
`;
